import React, {useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {Toolbar} from "@material-ui/core";
import ChromeTabs from "../../../controls/ChromeTabs";

import AircraftStyles from "../styles/AircraftStyles";
import AircraftScheduledMaintenanceList from "./AircraftScheduledMaintenanceList";
import AircraftDispatchDeviationsList from "./AircraftDispatchDeviationsList";

const AircraftMaintenance = (props) => {
  const classes = makeStyles(AircraftStyles)();

  const [state, setState] = useState({
    canEdit: props.canEdit,
    aircraftTailNumber: props.aircraftTailNumber,
    externalAircraftTailNumber: props.externalAircraftTailNumber,
    maintenanceInterface: props.maintenanceInterface,
    aircraftUuid: props.aircraftUuid,
  });

  const [messagingTabs, setMessagingTabs] = useState(
    [
      {label: "Scheduled", value: "scheduled"},
      {label: "Past", value: "past"},
      {label: "Dispatch Deviations", value: "dispatch"},
    ]
  );
  const [currentTab, setCurrentTab] = useState("scheduled");

  const handleTabChange = (e, i) => {
    setCurrentTab(i);
  }

  return (
    <div >
      <Toolbar variant={"dense"}>
        <ChromeTabs
          id={"AircraftMaintenance"}
          //style={{ alignSelf: "flex-end", display: "inline-block", align: "left" }}
          style={{ marginTop: 10, marginLeft: 50}}
          tabs={messagingTabs}
          tabStyle={{
            bgColor: "#E6E8EB",
            selectedBgColor: "#ffffff",
            color: "rgba(0,0,0,0.87)",
          }}
          tabProps={{
            disableRipple: false,
          }}
          value={currentTab}
          onChange={handleTabChange}
        />
      </Toolbar>
      <div style={{width: "100%"}}>
        {currentTab === "scheduled"
          ?
            <div>
              <AircraftScheduledMaintenanceList
                canEdit={state.canEdit}
                aircraftTailNumber={state.externalAircraftTailNumber}
                aircraftUuid={state.aircraftUuid}
                maintenanceInterface={state.maintenanceInterface}
                period={"current"}
              />
            </div>
          : currentTab === "past"
            ?
              <div>
                <AircraftScheduledMaintenanceList
                  canEdit={state.canEdit}
                  aircraftTailNumber={state.externalAircraftTailNumber}
                  aircraftUuid={state.aircraftUuid}
                  maintenanceInterface={state.maintenanceInterface}
                  period={"past"}
                />
              </div>
            :
              <div>
                <AircraftDispatchDeviationsList
                  canEdit={state.canEdit}
                  aircraftTailNumber={state.aircraftTailNumber}
                  aircraftUuid={state.aircraftUuid}
                />
              </div>
        }
      </div>
    </div>
  );
}

export default AircraftMaintenance;
